"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("./const");
var App = /** @class */ (function () {
    function App(config, session) {
        var _this = this;
        if (session === void 0) { session = {}; }
        this.config = config;
        this.session = session;
        this.autoIdPrefix = "cs-lpa";
        this.autoIdCounter = 1;
        this.shippingMethodSelected = false;
        this.initCheckout = function () {
            _this.disableOrderSubmitButton();
            _this.refreshCheckout();
            _this.initShippingMethod();
            _this.enableOrderSubmitButton();
        };
        this.renderButtons = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.payButton); _i < _a.length; _i++) {
                var element = _a[_i];
                _this.renderPayButton("#" + _this.getElementId(element, const_1.Role.payButton));
            }
            for (var _b = 0, _c = _this.getElementsByRole(const_1.Role.pdpPayButton); _b < _c.length; _b++) {
                var element = _c[_b];
                _this.renderPDPPayButton("#" + _this.getElementId(element, const_1.Role.pdpPayButton));
            }
            for (var _d = 0, _e = _this.getElementsByRole(const_1.Role.loginButton); _d < _e.length; _d++) {
                var element = _e[_d];
                _this.renderLoginButton("#" + _this.getElementId(element, const_1.Role.loginButton));
            }
        };
        this.logout = function () {
            switch (_this.session.page) {
                case undefined:
                    break;
            }
        };
        this.init = function () {
            _this.renderButtons();
            _this.initCheckout();
            return _this;
        };
        this.renderCheckoutButton = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.checkoutButton); _i < _a.length; _i++) {
                var element = _a[_i];
                amazon.Pay.renderButton("#" + _this.getElementId(element, const_1.Role.checkoutButton), _this.getCheckoutButtonConfig());
            }
        };
        this.xhrCall = function (url, params, callbacks) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                switch (xhr.readyState) {
                    case XMLHttpRequest.OPENED:
                        callbacks && callbacks.before && callbacks.before(xhr);
                        break;
                    case XMLHttpRequest.DONE:
                        if (xhr.status === 200) {
                            callbacks && callbacks.success && callbacks.success(xhr);
                        }
                        else {
                            callbacks && callbacks.error && callbacks.error(xhr);
                        }
                        callbacks && callbacks.after && callbacks.after(xhr);
                        break;
                }
            };
            xhr.open("post", url, true);
            xhr.send(params);
        };
        this.getElementById = function (id) { return document.getElementById(id); };
        this.getElementsByRole = function (role) { return document.querySelectorAll("[data-lpa-role=\"" + role + "\"]"); };
        this.getElementId = function (element, role) {
            if (!element.id) {
                element.id = _this.autoIdPrefix + "-" + role + "-" + _this.autoIdCounter++;
            }
            return element.id;
        };
        this.getPayButtonConfig = function () { return ({
            buttonColor: _this.config.payButtonColor,
            checkoutLanguage: _this.config.language,
            ledgerCurrency: _this.config.currency,
            merchantId: _this.config.merchantId,
            placement: const_1.ButtonPlacement.Cart,
            productType: _this.session.virtualOrder ? const_1.ProductType.PayOnly : const_1.ProductType.PayAndShip,
            sandbox: !!_this.config.sandbox,
        }); };
        this.getCheckoutButtonConfig = function () { return ({
            buttonColor: _this.config.payButtonColor,
            checkoutLanguage: _this.config.language,
            createCheckoutSessionConfig: {
                payloadJSON: _this.session.apb ? _this.session.apb.payload : null,
                signature: _this.session.apb ? _this.session.apb.signature : null,
            },
            ledgerCurrency: _this.config.currency,
            merchantId: _this.config.merchantId,
            placement: const_1.ButtonPlacement.Checkout,
            productType: _this.session.virtualOrder ? const_1.ProductType.PayOnly : const_1.ProductType.PayAndShip,
            publicKeyId: _this.config.publicKeyId,
            sandbox: !!_this.config.sandbox,
        }); };
        this.getLoginButtonConfig = function () { return ({
            buttonColor: _this.config.loginButtonColor,
            checkoutLanguage: _this.config.language,
            ledgerCurrency: _this.config.currency,
            merchantId: _this.config.merchantId,
            placement: const_1.ButtonPlacement.Cart,
            productType: const_1.ProductType.SignIn,
            sandbox: !!_this.config.sandbox,
            signInConfig: {
                payloadJSON: _this.session.login ? _this.session.login.payload : null,
                publicKeyId: _this.config.publicKeyId,
                signature: _this.session.login ? _this.session.login.signature : null,
            },
        }); };
        this.renderPayButton = function (buttonId) {
            var config = __assign(__assign({}, _this.getPayButtonConfig()), { createCheckoutSession: {
                    url: _this.config.urls.createCheckoutSession,
                } });
            var button = amazon.Pay.renderButton(buttonId, config);
        };
        this.renderPDPPayButton = function (buttonId) {
            var config = _this.getPayButtonConfig();
            var payButton = amazon.Pay.renderButton(buttonId, config);
            payButton.onClick(function () {
                _this.xhrCall(_this.config.urls.addToCart, new FormData(_this.getElementById(_this.config.addToCartForm || "")), {
                    success: function (xhr) {
                        var response = JSON.parse(xhr.responseText);
                        if (!response.success) {
                            alert(response.error_messages ? response.error_messages.join("\n") : "Undefined error");
                        }
                        else {
                            payButton.initCheckout({
                                createCheckoutSessionConfig: {
                                    payloadJSON: _this.session.pay ? _this.session.pay.payload : null,
                                    publicKeyId: _this.config.publicKeyId,
                                    signature: _this.session.pay ? _this.session.pay.signature : null,
                                },
                            });
                        }
                    },
                });
            });
        };
        this.renderLoginButton = function (buttonId) {
            var config = _this.getLoginButtonConfig();
            amazon.Pay.renderButton(buttonId, config);
        };
        this.refreshCheckout = function () {
            _this.disableOrderSubmitButton();
            _this.bindChangeActions();
            _this.bindShippingMethodChange();
            _this.bindCouponFormSubmit();
            _this.bindOrderSubmit();
            _this.enableOrderSubmitButton();
        };
        this.bindChangeActions = function () {
            if (_this.session.checkoutSessionId) {
                // bind change address action
                for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.changeAddress); _i < _a.length; _i++) {
                    var element = _a[_i];
                    element.onclick = function (event) { return event.preventDefault(); };
                    amazon.Pay.bindChangeAction("#" + _this.getElementId(element, const_1.Role.changeAddress), {
                        amazonCheckoutSessionId: _this.session.checkoutSessionId,
                        changeAction: const_1.ChangeAction.changeAddress,
                    });
                }
                // bind change payment action
                for (var _b = 0, _c = _this.getElementsByRole(const_1.Role.changePayment); _b < _c.length; _b++) {
                    var element = _c[_b];
                    element.onclick = function (event) { return event.preventDefault(); };
                    amazon.Pay.bindChangeAction("#" + _this.getElementId(element, const_1.Role.changePayment), {
                        amazonCheckoutSessionId: _this.session.checkoutSessionId,
                        changeAction: const_1.ChangeAction.changePayment,
                    });
                }
            }
        };
        this.initShippingMethod = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.selectShippingMethod); _i < _a.length; _i++) {
                var element = _a[_i];
                if (!element.querySelector("input[type=radio]:checked")) {
                    var firstShippingMethod = element.querySelector("input[type=radio]");
                    firstShippingMethod && (firstShippingMethod.checked = true);
                }
                element.onchange();
            }
        };
        this.bindShippingMethodChange = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.selectShippingMethod); _i < _a.length; _i++) {
                var element = _a[_i];
                element.onchange = _this.onShippingMethodChange(element);
            }
        };
        this.onShippingMethodChange = function (form) {
            return function () {
                _this.config.urls.saveShippingMethod && _this.xhrCall(_this.config.urls.saveShippingMethod, new FormData(form), {
                    after: _this.afterShippingMethodSave,
                    before: _this.beforeShippingMethodSave,
                    success: _this.onShippingMethodSaveSuccess,
                });
            };
        };
        this.beforeShippingMethodSave = function () {
            _this.shippingMethodSelected = false;
            _this.showPleaseWait();
            _this.disableOrderSubmitButton();
        };
        this.afterShippingMethodSave = function () {
            _this.hidePleaseWait();
        };
        this.onShippingMethodSaveSuccess = function (xhr) {
            var response = JSON.parse(xhr.responseText);
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.orderReview); _i < _a.length; _i++) {
                var element = _a[_i];
                element.update(response.html);
            }
            _this.shippingMethodSelected = true;
            _this.refreshCheckout();
            _this.enableOrderSubmitButton();
        };
        this.bindCouponFormSubmit = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.couponForm); _i < _a.length; _i++) {
                var form = _a[_i];
                for (var _b = 0, _c = _this.getElementsByRole(const_1.Role.couponApplyButton); _b < _c.length; _b++) {
                    var button = _c[_b];
                    button.onclick = _this.onCouponApply(form);
                }
                for (var _d = 0, _e = _this.getElementsByRole(const_1.Role.couponCancelButton); _d < _e.length; _d++) {
                    var button = _e[_d];
                    button.onclick = _this.onCouponCancel;
                }
            }
        };
        this.onCouponApply = function (form) {
            return function () {
                _this.config.urls.couponPost && _this.xhrCall(_this.config.urls.couponPost, new FormData(form), {
                    after: _this.afterCouponPost,
                    before: _this.beforeCouponPost,
                    success: _this.onCouponPostSuccess,
                });
            };
        };
        this.onCouponCancel = function () {
            _this.config.urls.couponPost && _this.xhrCall(_this.config.urls.couponPost, new FormData(), {
                after: _this.afterCouponPost,
                before: _this.beforeCouponPost,
                success: _this.onCouponPostSuccess,
            });
        };
        this.beforeCouponPost = function () {
            _this.showPleaseWait();
            _this.disableOrderSubmitButton();
        };
        this.afterCouponPost = function () {
            _this.hidePleaseWait();
        };
        this.onCouponPostSuccess = function (xhr) {
            var response = JSON.parse(xhr.responseText);
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.orderReview); _i < _a.length; _i++) {
                var element = _a[_i];
                element.update(response.html);
            }
            _this.refreshCheckout();
            _this.enableOrderSubmitButton();
        };
        this.bindOrderSubmit = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.submitOrder); _i < _a.length; _i++) {
                var element = _a[_i];
                element.onclick = _this.onOrderSubmit;
            }
        };
        this.onOrderSubmit = function () {
            if (_this.isOrderSubmissionAllowed()) {
                var customFieldsForm = _this.getElementsByRole(const_1.Role.customFields);
                if (customFieldsForm.length) {
                    _this.config.urls.saveOrderData && _this.xhrCall(_this.config.urls.saveOrderData, new FormData(customFieldsForm[0]), {
                        after: _this.afterOrderSubmit,
                        before: _this.beforeOrderSubmit,
                        success: _this.onOrderSubmitSuccess,
                    });
                }
                else {
                    _this.onOrderSubmitSuccess();
                }
            }
        };
        this.beforeOrderSubmit = function () {
            _this.showPleaseWait();
            _this.disableOrderSubmitButton();
        };
        this.afterOrderSubmit = function () {
            _this.hidePleaseWait();
        };
        this.onOrderSubmitSuccess = function () {
            _this.config.urls.placeOrder && (window.location.href = _this.config.urls.placeOrder);
        };
        this.showPleaseWait = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.pleaseWait); _i < _a.length; _i++) {
                var element = _a[_i];
                element.show();
            }
        };
        this.hidePleaseWait = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.pleaseWait); _i < _a.length; _i++) {
                var element = _a[_i];
                element.hide();
            }
        };
        this.isOrderSubmissionAllowed = function () { return !!(_this.session.checkoutSessionId
            && (_this.shippingMethodSelected || _this.session.virtualOrder)); };
        this.enableOrderSubmitButton = function () {
            if (_this.isOrderSubmissionAllowed()) {
                for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.submitOrder); _i < _a.length; _i++) {
                    var element = _a[_i];
                    element.disabled = false;
                    element.classList.remove("disabled");
                }
            }
            else {
                _this.disableOrderSubmitButton();
            }
        };
        this.disableOrderSubmitButton = function () {
            for (var _i = 0, _a = _this.getElementsByRole(const_1.Role.submitOrder); _i < _a.length; _i++) {
                var element = _a[_i];
                element.disabled = true;
                element.classList.add("disabled");
            }
        };
    }
    return App;
}());
exports.setup = function (config, session) { return new App(config, session); };
